import React, { Fragment, useState, useEffect, useContext } from 'react'

import AppContext from '../../../contexts/AppContext'
import useToastContext from "../../../hooks/useToastContext"
import { Helmet } from "react-helmet-async"

import { BannerPreview } from './Form'

const bannerProperty = (banner, property, defaultValue) => {
    return banner.options && banner.options.settings && banner.options.settings[property] ? banner.options.settings[property] : defaultValue
}


const Preview = ({ match, history }) => {

    const { bannerServices } = useContext(AppContext)

    const bannerId = match.params.id
    const title = "View Banner Ad"
    const [ loading, setLoading ] = useState(false)
    const [ banner, setBanner ] = useState(null)

    useEffect(() => {
        setLoading(true)
        bannerServices.show(bannerId, {placement: 'y'}).then(res => {
            setBanner(res.banner)
            setLoading(false)
        }).catch(res => {
            console.log('error')
            setLoading(false)
        })
    }, [])

    return (
        <>
            <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>
            {banner && <BannerPreview banner={banner} />}
        </>
    )
}

export default Preview
